import React from 'react';
import { Component } from '../../../../../../infrastructure/type-extensions';
import { CommonPopoverContext } from '../../../../../global/common-popover/common-popover.context';
import { CommonPopover } from '../../../../../global/common-popover/common-popover';
import { LinkItemInfoPopover } from './link-item-info.popover';

export const makeLinkInfoInPopover = <T extends { isOpen: boolean }>(PopoverTriggerComponent: Component<T>) => {
    // we need to utilize context.consumer in order to identify 'isOpen' value, but usage of popover forcing ref forwarding
    // therefore utilize React.forwardRef to create HOC over the PopoverTriggerComponent, which would utilize context and forward ref
    const ComponentWithForwardedRef = React.forwardRef<HTMLElement, T>((props: T, ref: React.Ref<HTMLElement>) => {
        return (
            <CommonPopoverContext.Consumer>
                {context => <PopoverTriggerComponent {...props} isOpen={context.isOpen} ref={ref} />}
            </CommonPopoverContext.Consumer>
        );
    });
    // T can not be casted to ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>
    // can't get the reason for this, but for now just cast targetComponentProps to any while passing to component with forwarded ref
    // tslint:disable:no-any
    return props => {
        return (
            <CommonPopover
                className='event-item-link__popover'
                body={<LinkItemInfoPopover {...props} />}
                position={['left', 'bottom']}
            >
                <ComponentWithForwardedRef {...props } />
            </CommonPopover>
            // tslint:enable:no-any
        );
    };
};
